import { useDispatch, useSelector } from "react-redux";

function useSessionFilters() {
  const dispatch = useDispatch();

  let sessionFiltersState = useSelector((state) => state.core.session["session_filters_state"])

  
  const updateSessionFilters = (newValues) => {


    const CURRENT_URL_PATH = window.location.pathname

    if (sessionFiltersState) {
      
      const currentState = sessionFiltersState[CURRENT_URL_PATH] || {}
      
      dispatch({
        type: "UPDATE_SESSION",
        key: "session_filters_state",
        value: {
          ...sessionFiltersState,
          [CURRENT_URL_PATH]:
          { ...currentState, ...newValues },
        },
      });
      
    } else {
      dispatch({
        type: "UPDATE_SESSION",
        key: "session_filters_state",
        value: {
          [CURRENT_URL_PATH]: newValues
        },
      });
    }

  }
  
  const getSavedFilters = () => {
    const CURRENT_URL_PATH = window.location.pathname

    if (sessionFiltersState) {
      const savedState = sessionFiltersState[CURRENT_URL_PATH]

      if (savedState) {
        return savedState
      }
    }

    return {}
  }

  const clearFilters = () => {
    const CURRENT_URL_PATH = window.location.pathname;
    const sessionFiltersStateCopy = { ...sessionFiltersState };
    delete sessionFiltersStateCopy[CURRENT_URL_PATH];

    dispatch({
      type: "UPDATE_SESSION",
      key: "session_filters_state",
      value: sessionFiltersStateCopy
    });
  };


  return {
    updateSessionFilters,
    getSavedFilters,
    clearFilters
  }
};

export default useSessionFilters;
